const combineUrlAndParams = (uri, params) => {
    const queryString = uri.includes('?') ? `&${params}` : `?${params}`;
    return uri + queryString;
};
export default combineUrlAndParams;
